import { ADMIN_CONSOLE_CONTENT_PROMOTION_PATHNAME } from "@/components/ContentPromotions/constants";

const ADMIN_CONSOLE_ROUTES = {
  ADMIN_CONSOLE: "/admin",
  REPORTING: "/reports/admin/usage-report",
  STUDENTS: "/admin/students",
  SCHOOLS: "/admin/schools",
  CLASS_ROOMS: "/admin/classrooms",
  TEACHERS: "/admin/faculty",
  CONTENT_ADVISORY: "/admin/content-advisory",
  CONTENT_RESTRICTION: "/admin/content-restriction",
  ADMIN_QUICK_START: "/admin/implementation-guide",
  CONTENT_PROMOTION: ADMIN_CONSOLE_CONTENT_PROMOTION_PATHNAME,
};

export default ADMIN_CONSOLE_ROUTES;
